const app = {
  state: {
    login: false,
    rightBar: true,
    category: 0,
    config: {},
    device: 0, // 0pc,1mobile
    nowPage: true,
    userInfo:{}, // 登录的用户信息
  },
  mutations: {
    SET_TAB: (state, data) => {
      state.category = data.category
    },
    SET_DEVICE: (state, data) => {
      state.device = data
    },
    SET_CONFIG: (state, data) => {
      state.config = data
    },
    SET_LOGIN: (state, data) => {
      state.login = data
    },
    SET_RIGHTBAR: (state, data) => {
      state.rightBar = data
    },
    SET_NOWPAGE: (state, data) => {
      state.nowPage = data
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data
    },
  },
  actions: {
    setRightBar({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_RIGHTBAR', data)
        resolve()
      })
    },
    setTab({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_TAB', data)
        resolve()
      })
    },
    setDevice({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_DEVICE', data)
        resolve()
      })
    },
    setConfig({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_CONFIG', data)
        resolve()
      })
    },
    setLogin({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_LOGIN', data)
        resolve()
      })
    },
    setNowPage({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_NOWPAGE', data)
        resolve()
      })
    },
    setUserInfo({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_USERINFO', data)
        resolve()
      })
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js